import { Box, Heading, Text, Button } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Quay lại trang trước đó
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <Box className="p-8 bg-white rounded-lg shadow-lg">
        <Heading as="h1" className="text-3xl font-semibold text-gray-800 mb-4">
          Truy cập bị từ chối
        </Heading>
        <Text className="text-lg text-gray-600 mb-6">
          Bạn không có quyền truy cập trang này.
        </Text>
        <br></br>
        <Button
          onClick={handleGoBack}
          className="mt-5 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-300"
        >
          Quay lại
        </Button>
      </Box>
    </div>
  );
};

export default Unauthorized;
